import './style.scss'

import React from 'react'
import { useActions, useValues } from 'kea'

import I18n from 'lib/i18n'
import ClickOutside from 'lib/tags/click-outside'

import FilterButton from './filter-button'
import SubMenuPopup from './sub-menu-popup'

import filtersLogic from '~/scenes/search/filters-page/logic'
import sceneLogic from '~/scenes/search/logic'

const HeaderFilter = () => {
  const {
    isLocationFilterActive,
    isLanguageFilterActive,
    isAgeFilterActive,
    locationFilterContent,
    ageFilterContent,
    activeSubMenu,
    isSubMenuActive,
    isPriceFilterVisible,
    isLanguageFilterVisible,
    isPriceFilterActive,
    isMoreFiltersActive,
    activeFiltersCount,
    priceFilterContent,
    showTeacherSpeaksFilter,
    isCategoryTagsFiltersActive,
    shouldIgnoreCategoryTagsFilter
  } = useValues(filtersLogic)

  const { showingFavourites, results } = useValues(sceneLogic)
  const { setOpenFilters } = useActions(sceneLogic)

  const { openFilter, applyFilter, clearChanges } = useActions(filtersLogic)

  const handleClickOutside = () => {
    if (activeSubMenu === 'category_tags' && shouldIgnoreCategoryTagsFilter) {
      clearChanges()
      setOpenFilters('')
      return
    }

    if (activeSubMenu && activeSubMenu !== 'map') {
      applyFilter('')
    }
  }

  const updateActiveFilterPage = target => {
    if (activeSubMenu) {
      applyFilter(activeSubMenu !== target ? target : '')
    } else {
      openFilter(target)
    }
  }

  const categoryTags = results.category_tags
  return (
    <div className='filter-container-wrapper'>
      {!showingFavourites && (
        <ClickOutside onClickOutside={handleClickOutside}>
          <div className='filter-container'>
            <FilterButton
              itemId='header-filter-button-location'
              active={isLocationFilterActive}
              smallContent={I18n.t('bookings.show.lesson_location')}
              largeContent={locationFilterContent}
              onClick={() => updateActiveFilterPage('location')}
            >
              {isSubMenuActive && activeSubMenu === 'location' && <SubMenuPopup />}
            </FilterButton>

            {isLanguageFilterVisible && showTeacherSpeaksFilter && (
              <FilterButton
                itemId='header-filter-button-alsoSpeak'
                active={isLanguageFilterActive}
                smallContent={I18n.t('react.search.filters.teacher_speak.filter_text')}
                largeContent={I18n.t('react.search.filters.teacher_speak.filter_text')}
                onClick={() => updateActiveFilterPage('language')}
              >
                {isSubMenuActive && activeSubMenu === 'language' && <SubMenuPopup />}
              </FilterButton>
            )}

            <FilterButton
              itemId='header-filter-button-age'
              active={isAgeFilterActive}
              smallContent={I18n.t('activerecord.attributes.message.student_age')}
              largeContent={ageFilterContent}
              onClick={() => updateActiveFilterPage('age')}
            >
              {isSubMenuActive && activeSubMenu === 'age' && <SubMenuPopup />}
            </FilterButton>

            {categoryTags && categoryTags.length !== 0 && (
              <FilterButton
                itemId='header-filter-button-category_tags'
                active={isCategoryTagsFiltersActive}
                smallContent={I18n.t('react.search.all_filters.options')}
                largeContent={I18n.t('react.search.all_filters.options')}
                onClick={() => updateActiveFilterPage('category_tags')}
              >
                {isSubMenuActive && activeSubMenu === 'category_tags' && <SubMenuPopup />}
              </FilterButton>
            )}

            {isPriceFilterVisible && (
              <FilterButton
                itemId='header-filter-button-price'
                active={isPriceFilterActive}
                smallContent={priceFilterContent}
                largeContent={priceFilterContent}
                onClick={() => updateActiveFilterPage('price')}
              >
                {isSubMenuActive && activeSubMenu === 'price' && <SubMenuPopup />}
              </FilterButton>
            )}

            <FilterButton
              itemId='header-filter-button-all'
              active={isMoreFiltersActive}
              smallContent={
                <>
                  {I18n.t('react.search.filters.filters_button')}
                  {activeFiltersCount !== 0 ? ` · ${activeFiltersCount}` : ''}
                </>
              }
              largeContent={
                <>
                  {I18n.t('react.search.filters.more_filters_button')}
                  {activeFiltersCount !== 0 ? ` · ${activeFiltersCount}` : ''}
                </>
              }
              onClick={() => updateActiveFilterPage('all')}
            >
              {isSubMenuActive && activeSubMenu === 'all' && <SubMenuPopup />}
            </FilterButton>
          </div>
        </ClickOutside>
      )}

      {isSubMenuActive && <div className='sub-menu-popup-overlay' />}
    </div>
  )
}

export default HeaderFilter
